import { render, staticRenderFns } from "./EventModalMontagePasses.vue?vue&type=template&id=6fdcc904&scoped=true"
import script from "./EventModalMontagePasses.vue?vue&type=script&lang=js"
export * from "./EventModalMontagePasses.vue?vue&type=script&lang=js"
import style0 from "./EventModalMontagePasses.vue?vue&type=style&index=0&id=6fdcc904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcc904",
  null
  
)

export default component.exports